import { render, staticRenderFns } from "./BEMessagesPage.vue?vue&type=template&id=7d538814&scoped=true&"
import script from "./BEMessagesPage.vue?vue&type=script&lang=js&"
export * from "./BEMessagesPage.vue?vue&type=script&lang=js&"
import style0 from "./BEMessagesPage.vue?vue&type=style&index=0&id=7d538814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d538814",
  null
  
)

export default component.exports